module.exports = __webpack_public_path__ + "static/img/3.a987b4c9.jpeg";